/* eslint-disable @next/next/no-img-element */
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import cn from 'classnames'
import { FC, useCallback } from 'react'

import styles from './ImageView.module.scss'

import Button from '~elements/Button'
import DownloadIcon from '~icons/download.svg'
import TrashIcon from '~icons/trash.svg'
import { downloadFromS3 } from '~lib/s3'
import { downloadFile } from '~lib/utils/files'

const ImageView: FC<React.PropsWithChildren<NodeViewProps>> = ({ editor, node, selected, deleteNode }) => {
  const { filename, src, ...restAttrs } = node.attrs

  const handleDownloadClick = useCallback(async () => {
    const name = filename || decodeURIComponent(src.split('/').reverse()[0])
    if (src.includes('blob')) downloadFile({ url: src, name })
    else {
      try {
        const url = await downloadFromS3(src)
        downloadFile({ url, name })
      } catch (error) {
        console.error(error)
      }
    }
  }, [filename, src])

  return (
    <NodeViewWrapper className={cn(styles.root, { [styles.selected]: selected })}>
      <div className={styles.inner} contentEditable="false" data-drag-handle>
        <div className={styles.controls}>
          <Button icon={<DownloadIcon />} size="s" onClick={handleDownloadClick} />
          {editor.isEditable && <Button icon={<TrashIcon />} size="s" variant="attention" onClick={deleteNode} />}
        </div>
        <img alt="" src={src} {...restAttrs} />
      </div>
    </NodeViewWrapper>
  )
}

export default ImageView
